import { ESPopover } from '@energy-stacks/core/ui';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useEditTourDetailsContext } from './useEditTourDetailsContext';
import { useTranslation } from 'react-i18next';

type JobOrderTableCellProps = {
  order: number;
  isViolatingNextDayTour: boolean;
};

export const JobOrderTableCell: React.FC<JobOrderTableCellProps> = ({
  order,
  isViolatingNextDayTour,
}) => {
  const theme = useTheme();
  const [t] = useTranslation('tours');
  const { isTourChanged } = useEditTourDetailsContext();

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Box
        sx={{
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore dark exists on theme.palette
          backgroundColor: theme.palette.dark.main,
          width: 28,
          height: 28,
          p: 1,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography fontWeight={500} color={theme.palette.background.paper}>
          {order}
        </Typography>
      </Box>
      {isViolatingNextDayTour && isTourChanged ? (
        <ESPopover content={t('nextDayTourContaminationViolation')}>
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path
              d="M10.6251 6.61458H12.4584V8.44792H10.6251V6.61458ZM10.6251 10.2812H12.4584V15.7812H10.6251V10.2812ZM11.5418 2.03125C6.48178 2.03125 2.37511 6.13792 2.37511 11.1979C2.37511 16.2579 6.48178 20.3646 11.5418 20.3646C16.6018 20.3646 20.7084 16.2579 20.7084 11.1979C20.7084 6.13792 16.6018 2.03125 11.5418 2.03125ZM11.5418 18.5312C7.49928 18.5312 4.20844 15.2404 4.20844 11.1979C4.20844 7.15542 7.49928 3.86458 11.5418 3.86458C15.5843 3.86458 18.8751 7.15542 18.8751 11.1979C18.8751 15.2404 15.5843 18.5312 11.5418 18.5312Z"
              fill={theme.palette.primary.main}
            />
          </svg>
        </ESPopover>
      ) : null}
    </Stack>
  );
};
